import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { assertIsClientContext, context } from '@adornis/baseql/server/context.js';
import { setUserOnContext } from '@adornis/users/server/baseqlContextHelper.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

/**
 * Hand the session back to the administrator who started the impersonation.
 *
 * Deliberately no permission check: the caller is the taken-over account, which has none —
 * the right to end it comes from `impersonatingUser` being on this very session. Should
 * that administrator have been deactivated meanwhile, the ContextManager upgrade that
 * setUserOnContext triggers empties the session and the client drops to the login screen.
 */
export const endImpersonation = registerMutation({
  type: () => Boolean,
  operationName: 'endImpersonation',
  resolve: () => {
    return async () => {
      assertIsClientContext(context);
      const administratorID = context.impersonatingUser;
      const administratorClass = context.impersonatingUserClass;
      const impersonatedUserID = context.userID;
      if (!administratorID) throw new ExpectedError('Für diese Sitzung läuft keine Übernahme.');

      context.impersonatingUser = undefined;
      context.impersonatingUserClass = undefined;
      await setUserOnContext({ _id: administratorID, _class: administratorClass });

      logger.info({ userID: administratorID, impersonatedUserID }, 'Impersonation beendet');
      return true;
    };
  },
  params: [],
});
